import { render, staticRenderFns } from "./shopHome.vue?vue&type=template&id=4dbf2c23&scoped=true&"
import script from "./shopHome.vue?vue&type=script&lang=js&"
export * from "./shopHome.vue?vue&type=script&lang=js&"
import style0 from "./shopHome.vue?vue&type=style&index=0&id=4dbf2c23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbf2c23",
  null
  
)

export default component.exports